import {useEffect,useState} from 'react';

type Notice={id:string;taskId:string;title:string;status:string;
  read:boolean;createdAt:string};
type Data={permitted:boolean;unreadCount:number;notifications:Notice[]};
/** Top-left message-icon support notifications; no external SMS/email. */
export function SupportNotifications({locationCode,onOpenTask}:{
  locationCode:string;onOpenTask:(taskId:string)=>void;
}){
  const [feed,setFeed]=useState<Data|null>(null);
  const [error,setError]=useState('');
  const refresh=async(signal?:AbortSignal)=>{
    const response=await fetch('/api/v1/staff/support/notifications?'+
      new URLSearchParams({location:locationCode}),{
        credentials:'same-origin',cache:'no-store',signal});
    const body=await response.json() as {ok:boolean;data?:Data};
    if(!response.ok||!body.ok||!body.data)
      throw Error('Support notifications unavailable.');
    if(!signal?.aborted){setFeed(body.data);setError('');}
  };
  useEffect(()=>{
    const controller=new AbortController();
    setFeed(null);setError('');
    const load=()=>void refresh(controller.signal).catch(()=>{
      if(!controller.signal.aborted)setError('Support notifications unavailable.');
    });
    load();
    window.addEventListener('ecfs:feedback-submitted',load);
    return ()=>{controller.abort();window.removeEventListener('ecfs:feedback-submitted',load);};
  },[locationCode]);
  const open=async(notice:Notice)=>{
    try{
      if(!notice.read){
        const response=await fetch('/api/v1/staff/support/notifications/'+
          encodeURIComponent(notice.id),{
          method:'PATCH',credentials:'same-origin',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({location:locationCode}),
        });
        if(!response.ok)throw Error('Notification could not be marked read.');
      }
      onOpenTask(notice.taskId);
    }catch(e){setError(e instanceof Error?e.message:'Notification unavailable.');}
  };
  if(error)return <p role="alert">{error}</p>;
  if(!feed)return <p role="status">Loading notifications…</p>;
  if(!feed.permitted)return <p className="ecfs-messaging-empty">
    No App Support notifications for this account.</p>;
  if(feed.notifications.length===0)return <p className="ecfs-messaging-empty">
    No notifications yet.</p>;
  return <div className="ecfs-support-notifications" aria-label="App Support notifications">
    <small>{feed.unreadCount} unread support notification(s)</small>
    {feed.notifications.map(n=><button type="button" key={n.id}
      className={n.read?'is-read':'is-unread'} onClick={()=>void open(n)}>
      <strong>{n.title}</strong><small>{n.status}{n.read?'':' · Unread'}</small>
    </button>)}
  </div>;
}
